/**
 * Creates title for cargo item based on
 * item product and container.
 * @param {string} product - product in current item.
 * @param {string} container - container used in current item.
 * @returns {string} - item title.
 */

export const createTitle = (product, container) => {
  let title = '';
  if (product) {
    title += ` ${product}`;
  }
  if (product && container) {
    title += `/${container}`;
  } else if (container) {
    title += ` ${container}`;
  }

  return title;
};
